import {
  GetServerSidePropsContext,
  InferGetServerSidePropsType,
  NextPage,
} from 'next';
import nookies from 'nookies';
import { useEffect, useRef, useState } from 'react';
import GNOBanner from '../../components/careerguide/GNOBanner';
import Header from '../../components/wherewego/Header';
import getUserByUIDRequest from '../../lib/api/getUserByUIDRequest';
import { firebaseAdmin } from '../../lib/config/firebaseAdmin';
import { useAuth } from '../../lib/providers/authProvider';
import GNOSubHeader from '../../components/careerguide/GNOSubHeader';
import CareerGuideResults from '../../components/careerguide/CareerGuideResults';
import Footer from '../../components/wherewego/Footer';
import { useRouter } from 'next/router';
import CareerQuiz from '../../components/careerguide/CareerQuiz';

export type CareerSearchParams = {
  style?: string;
  type?: string;
  outlook?: string;
  salary?: string;
  industry?: string;
};

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const query = ctx.query;
  try {
    const cookies = nookies.get(ctx);
    const token = await firebaseAdmin.auth().verifyIdToken(cookies.token);
    const { uid } = token;
    const email = token.email as string | null;
    const phone = token.phone_number as string | null;
    const user = await getUserByUIDRequest(uid, email, phone, cookies.token);
    return {
      props: {
        serverUser: token,
        serverSeeker: user,
        quiz: false,
      },
    };
  } catch (err) {
    return {
      props: {
        serverUser: null,
        serverSeeker: null,
        query: query,
        quiz: false,
      },
    };
  }
}

const CareerGuidePage: NextPage<
  InferGetServerSidePropsType<typeof getServerSideProps>
> = ({ serverUser, serverSeeker, quiz }) => {
  if (!quiz) {
    quiz = false;
  }
  const router = useRouter();
  const { setUser, setSeeker } = useAuth();
  const [page, setPage] = useState(1);

  const initializeParameters = () => {
    // set any default states
    const params = router.query;
    if (!params.sortBy) {
      params.sortBy = 'brightOutlook';
    }
    router.replace(router, undefined, { scroll: false });
  };

  useEffect(() => {
    setUser(serverUser);
    setSeeker(serverSeeker);
    initializeParameters();
  }, []);
  const resultsRef = useRef<HTMLDivElement>(null);
  const [potentialFilters, setPotentialFilters] = useState({} as any);

  return (
    <>
      <Header />
      <main>
        <section className="py-10 md:py-28">
          <GNOBanner />
        </section>
        <div id="results"></div>
        <GNOSubHeader
          setPage={setPage}
          setPotentialFilters={setPotentialFilters}
          potentialFilters={potentialFilters}
        />
        <section className="container px-8 py-8 mx-auto">
          <CareerGuideResults page={page} setPage={setPage} />
        </section>
      </main>
      <CareerQuiz
        setPotentialFilters={setPotentialFilters}
        resultsRef={resultsRef}
        initialState={quiz}
        setPage={setPage}
        potentialFilters={potentialFilters}
      />
      <Footer />
    </>
  );
};

export default CareerGuidePage;
